import { FC, ReactNode } from 'react'
import styles from 'components/features/future/FutureInputDecoration/FutureInputWithControl.styl'

type FutureInputWithControlProps = {
  control?: ReactNode
}
export const FutureInputWithControl: FC<FutureInputWithControlProps> = (props) => {
  const { children, control } = props
  return (
    <div className={ styles.genericInputWithControl }>
      <div className={ styles.left }>
        { children }
      </div>
      { !!control && (
        <div className={ styles.right }>
          { control }
        </div>
      )}
    </div>
  )
}
